import React from 'react';
import Header from '../../components/Header/Header';
import Hero from '../../components/Hero/Hero';
import Services from '../../components/ServiceLoop/ServiceLoop';
import About from '../../components/aboutinhome/About';
import MovingTextLoop from '../../components/MovingTextLoop/MovingTextLoop';
import ScrollStackSection from '../../components/ScrollStackSection/ScrollStackSection';
import LegalAdvisor from '../../components/LegalAdvisor/LegalAdvisor';
import HomeBlogSection from '../../components/HomeBlogSection/HomeBlogSection';
import FAQSection from '../../components/FAQSection/FAQSection';
import Footer from '../../components/Footer/Footer';
import './HomePage.css';

const HomePage: React.FC = () => {
  return (
    <div className="homepage">
      <Header />
      <Hero />
      <Services />
      <About />
      <MovingTextLoop />
      <ScrollStackSection />
      <LegalAdvisor />
      <FAQSection />
      <HomeBlogSection />
      <Footer />
    </div>
  );
};

export default HomePage;
